// extracted by mini-css-extract-plugin
export default {"downloadBtn":"DownloadBtn_downloadBtn__qRzpr"};